import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import stripAttr from 'strip-attributes'
import textReplace from 'utils/textReplace'
import textAsReactComponent from 'utils/textAsReactComponent'
import style from './Text.module.css'

const TextParagraph = ({ text }) => {
  let markup = stripAttr(textReplace(text.value), { omit: ['style'] })
  markup = markup.replace(/(<META|<meta)+([a-zA-Z0-9 ='"\-!#@*<]{1,}|)+(>)/, '')

  return <div className={style.wrapper}>{textAsReactComponent(markup)}</div>
}

TextParagraph.propTypes = {
  text: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment TextParagraphFragment on ParagraphText {
      id
      text: fieldText {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { TextParagraph, fragments }
